export default __webpack_public_path__ + "static/video-background-0974a3c7785504b0afa81e9bb47dcff0.jpg";